import { Layout, Input, Flex, Space, Tooltip, Typography, Button, theme } from "antd";
import { HeaderApp, NavigationBar } from "../../shared";
import { PlusOutlined, UserOutlined, SearchOutlined, FilterOutlined } from "@ant-design/icons";
import HeaderPage from "../../shared/components/HeaderPage";
import EmptyData from "../../shared/components/EmptyData";
import { useFetchProviders } from "../hooks/useFetchProviders";
import Loading from "../../shared/components/Loading";
import { useNavigate } from "react-router-dom";
import HybridCard from "../../shared/components/HybridCard";
import DrawerDetails from "../../shared/components/DrawerDetails";
import { useState } from "react";
import type { ProviderData } from "../types";
import ProviderDetails from "../components/ProviderDetails";

const Providers: React.FC = () => {
	const { data: providers, isLoading } = useFetchProviders();
	const navigate = useNavigate();
	const [selectedProvider, setSelectedProvider] = useState<ProviderData | null>(null);
	const [searchOpen, setSearchOpen] = useState(false);
	const [searchText, setSearchText] = useState("");
	const { token } = theme.useToken();


	if (isLoading) {
		return <Loading />
	}

	const filteredProviders = providers?.filter((p) => {
		if (!searchText) return true;
		const lowerSearch = searchText.toLowerCase();
		return (
			p.name_provider.toLowerCase().includes(lowerSearch) ||
			p.email_provider.toLowerCase().includes(lowerSearch)
		);
	}) || [];
	return (
		<>
			<HeaderApp sectionName="Catalogo | Proveedores" showBack />
			<Layout.Content style={{ padding: "16px", width: "100%", backgroundColor: token.colorBgLayout }} className="max-width-container">
				<HeaderPage
					title="Proveedores"
					subtitle="Gestionar tus proveedores"
					actions={[
						{
							label: "Agregar proveedor",
							icon: <PlusOutlined />,
							type: "primary",
							onClick: () => {
								navigate("/catalogo/proveedores/nuevo");
							},
						},
					]}
				/>
				{/* List Header */}
				<Flex
					justify="space-between"
					align="center"
					style={{ marginBottom: 12, padding: "0 4px" }}
				>
					<Typography.Text strong style={{ fontSize: 15 }}>
						Listado
					</Typography.Text>
					<Space>
						{searchOpen && (
							<Input
								prefix={<SearchOutlined />}
								placeholder="Buscar proveedor..."
								size="small"
								autoFocus
								style={{ borderRadius: 8, width: 200 }}
								value={searchText}
								onChange={(e) => setSearchText(e.target.value)}
								onBlur={() => {
									if (!searchText) setSearchOpen(false);
								}}
							/>
						)}
						<Tooltip title="Filtrar">
							<Button
								type="text"
								icon={<FilterOutlined />}
								shape="default"
								style={{ borderRadius: 8 }}
							/>
						</Tooltip>
						<Tooltip title="Buscar">
							<Button
								type="text"
								icon={<SearchOutlined />}
								shape="default"
								style={{ borderRadius: 8 }}
								onClick={() => setSearchOpen(true)}
							/>
						</Tooltip>
					</Space>
				</Flex>
				<main>
					{filteredProviders.length === 0 ?
						<EmptyData
							description="No hay proveedores registrados"
						/>
						: filteredProviders.map((provider) => (
							<HybridCard
								key={provider.id_provider}
								title={provider.name_provider}
								description={provider.email_provider}
								icon={<UserOutlined />}
								swipe={{
									onView: () => setSelectedProvider(provider),
								}}
							/>
						))}
				</main>
				<DrawerDetails
					title="Detalles proveedor"
					onClose={() => {
						setSelectedProvider(null)
					}}
					open={!!selectedProvider}
					contentBody={
						selectedProvider ? <ProviderDetails provider={selectedProvider} /> : null
					}
				/>
				<NavigationBar activeKey="/providers" />
			</Layout.Content>
		</>
	);
};

export default Providers;